const state = {
    selectedProvider: null, //stores the selected provider(used in form modal)
    providerShow: false, //show=true | edit=false
    formProvider: null,
    showProviderModal: false,//controls if the form modal is displayed or not
};

const getters = {
    getSelectedProvider(state, getters){
        if(!state.selectedProvider){
            state.selectedProvider = getters.getNewProvider;
        }
        return state.selectedProvider;
    },
    getFormProvider(state, getters){
        if(!state.formProvider){
            state.formProvider = getters.getEmptyFormProvider;
        }
        return state.formProvider;
    },
    getProviderShow(state){
        return state.providerShow;
    },
    getShowProviderModal(state){
        return state.showProviderModal;
    },

    getNewProvider(){
        return {
            id: '',
            name: '',
            companies_id: '',
            nif: '',
            countries_id: '',
            cities_id: '',
            address: '',
            types_company_type_id: '',
            postal_code: '',
            active_state: '',
            website: '',
            category: '',
            subcategory: '',
            contacts_json: [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}],
            description: '',
            created_at: '',
        };
    },

    getEmptyFormProvider(){
        return {
            id: '',
            name: '',
            companies_id: '',
            nif: '',
            types_company_type_id: '',
            countries_id: '',
            cities_id: '',
            address: '',
            postal_code: '',
            active_state: '',
            website: '',
            category: '',
            subcategory: '',
            description: '',
            contacts_json: [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}],
        }
    },
};

const mutations = {
    setSelectedProvider(state, payload){ //this also works for new article
        state.selectedProvider = payload;
    },
    setFormProvider(state, payload){ //this also works for new article
        state.formProvider = payload;
    },
    setPreparedFormProvider(state, payload){
        if(!payload) return;
        let array = [];
        if(payload.contacts_json){
            array = payload.contacts_json instanceof Array ? array = payload.contacts_json : JSON.parse(payload.contacts_json)
        }

        state.formProvider = {
            id: payload ? payload.id : '',
            name: payload ? payload.name : '',
            nif: payload ? payload.nif : '',
            types_company_type_id: payload ? payload.types_company_type_id : '',
            countries_id: payload ? payload.countries_id : '',
            cities_id: payload ? payload.cities_id : '',
            address: payload ? payload.address : 0,
            postal_code: payload ? payload.postal_code : '',
            active_state: payload ? payload.active_state : '',
            website: payload ? payload.website : '',
            companies_id: payload ? payload.companies_id : '',
            category : payload ? payload.category_id : '',
            subcategory: payload ? payload.subcategory_id : '',
            description: payload ? payload.description : '',
            contacts_json: payload ? payload.contacts_json : [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}],
        };
    },
    setProviderShow(state, payload){ //this also works for new article
        state.providerShow = payload;
    },
    setShowProviderModal(state, payload){
        state.showProviderModal = payload;
    },
};

const actions = {
    setSelectedProvider( {commit}, payload){
        commit('setSelectedProvider', payload);
        commit('setPreparedFormProvider', payload);
    },
    setProviderShow({commit}, payload){
        commit('setProviderShow', payload);
    },
    setShowProviderModal({commit}, payload){
        commit('setShowProviderModal', payload);
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};

